import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { Sparkles, RefreshCw } from 'lucide-react';
import { functions } from '../../../firebase';

function levelLabel(v) {
  if (v < 0.7) return 'Vide';
  if (v < 1.5) return 'Moyen';
  return 'Blindé';
}

function classFor(v) {
  if (v < 0.7) return 'est-pred-cell est-live-low';
  if (v < 1.5) return 'est-pred-cell est-live-mid';
  return 'est-pred-cell est-live-high';
}

function PredictionPanel({ crousId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const run = async () => {
    setLoading(true);
    setError(null);
    try {
      const fn = httpsCallable(functions, 'predictCrousAffluence');
      const res = await fn({ crousId, hoursAhead: 8 });
      setData(res.data);
    } catch (err) {
      setError(err.message || 'Erreur de prédiction');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="est-card">
      <div className="est-card-head">
        <div>
          <span className="est-kicker">Prédiction</span>
          <h2>Affluence anticipée</h2>
          <p className="est-muted">
            Basée sur l'historique agrégé et analysée par Gemini. Utile pour anticiper
            les pics et ajuster les effectifs.
          </p>
        </div>
        <button type="button" className="est-btn est-btn-secondary" onClick={run} disabled={loading}>
          {loading ? <RefreshCw size={16} className="is-spinning" /> : <Sparkles size={16} />}
          {data ? 'Rafraîchir' : 'Lancer la prédiction'}
        </button>
      </div>

      {error && <div className="est-alert est-alert-error">{error}</div>}

      {!data && !loading && !error && (
        <div className="est-empty est-empty-small">
          Clique sur « Lancer la prédiction » pour estimer les 8 prochaines heures.
        </div>
      )}

      {data && data.note && data.hours.length === 0 && (
        <div className="est-empty est-empty-small">{data.note}</div>
      )}

      {data && data.hours.length > 0 && (
        <>
          <div className="est-pred-grid">
            {data.hours.map((h) => (
              <div key={h.hour} className={classFor(h.level)}>
                <div className="est-pred-hour">{h.hour}h</div>
                <div className="est-pred-level">{h.level.toFixed(1)}</div>
                <div className="est-pred-label">{levelLabel(h.level)}</div>
                <div className="est-pred-conf">Confiance {Math.round(h.confidence * 100)}%</div>
                {h.note && <div className="est-pred-note">{h.note}</div>}
              </div>
            ))}
          </div>
          <div className="est-hint">
            Généré à {new Date(data.generatedAt).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}.
            La prédiction s'affine avec plus de données historiques.
          </div>
        </>
      )}
    </div>
  );
}

export default PredictionPanel;
